import { useEffect, useState } from "react";

import { INSTANT_QR_PROTOTYPE_READY_DELAY_MS } from "@/lib/instant-qr-prototype";

export function useInstantQrPrototypeReady(enabled = false) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    const timeoutId = window.setTimeout(
      () => setReady(true),
      INSTANT_QR_PROTOTYPE_READY_DELAY_MS,
    );
    return () => window.clearTimeout(timeoutId);
  }, [enabled]);

  return enabled && ready;
}
